// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@tps/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        &,
        .home-page-link {
            max-width: 160px;
            max-height: 42px;
            ${xScreen("lte", "md")} {
                max-width: 154px;
                max-height: 40px;
            }
        }
    `,
};

logoStyles.img = {
    css: css`
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        min-height: 40px;
        img {
            height: auto;
            max-height: 42px;
            ${xScreen("lte", "md")} {
                max-height: 40px;
            }
        }
    `,
};

logoStyles.image = {
    css: css`
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        min-height: 40px;
        img {
            height: auto;
            max-height: 42px;
            ${xScreen("lte", "md")} {
                max-height: 40px;
            }
        }
    `,
};

logoStyles.hiddenStyle={
    css: css`
        display: flex;
    `,
}
